<script>
    export default {
        name: "HamburgerOptionsMixin",
        computed: {
            hasHamburgerContent () {
                if (this.getShowInHamburger()) {
                    return true;
                }

                return false;
            }
        },
        methods: {
            getShowInHamburger () {
                return this.myData.inHamburger || false;
            },
            setShowInHamburger (eventData) {
                this.changeMyData({inHamburger: eventData.value});
                this.setChangesAreSaved(false);
            },
            getHamburgerContent () {
                let hamburgerOptions = [];

                let hamburgerOptionData = {
                    text : this.myNode.innerText,
                    html : this.myNode.innerHTML,
                    id: this.myNode.id,
                    className: this.myNode.className,
                    href: null,
                }

                if (this.myData.linkData && this.linkTypesUsingAnchors.includes(this.myData.linkData.linkType)) {
                    hamburgerOptionData.href = this.createHrefForLink(this.myData.linkData);
                }

                hamburgerOptions.push(hamburgerOptionData);
                return hamburgerOptions;
            }
        }
    }
</script>

